"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 0 0 1px 0;\n"], ["\n  display: flex;\n  padding: 0 0 1px 0;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div.withConfig({
  displayName: "GlobeIcon__Container",
  componentId: "sc-1bo831h-0"
})(_templateObject);

var GlobeIcon = function GlobeIcon() {
  return _react2.default.createElement(
    Container,
    null,
    _react2.default.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none"
      },
      _react2.default.createElement("path", {
        d: "M6.99413 1.16675C3.77413 1.16675 1.16663 3.78008 1.16663 7.00008C1.16663 10.2201 3.77413 12.8334 6.99413 12.8334C10.22 12.8334 12.8333 10.2201 12.8333 7.00008C12.8333 3.78008 10.22 1.16675 6.99413 1.16675ZM11.0366 4.66675H9.31579C9.13322 3.94427 8.86288 3.24685 8.51079 2.59008C9.57486 2.95642 10.4715 3.69359 11.0366 4.66675ZM6.99996 2.35675C7.48413 3.05675 7.86329 3.83258 8.11413 4.66675H5.88579C6.13663 3.83258 6.51579 3.05675 6.99996 2.35675ZM2.48496 8.16675C2.39163 7.79342 2.33329 7.40258 2.33329 7.00008C2.33329 6.59758 2.39163 6.20675 2.48496 5.83342H4.45663C4.40996 6.21842 4.37496 6.60342 4.37496 7.00008C4.37496 7.39675 4.40996 7.78175 4.45663 8.16675H2.48496ZM2.96329 9.33342H4.68413C4.87079 10.0626 5.13913 10.7626 5.48913 11.4101C4.42394 11.0458 3.5267 10.3081 2.96329 9.33342V9.33342ZM4.68413 4.66675H2.96329C3.5267 3.6921 4.42394 2.95441 5.48913 2.59008C5.13704 3.24685 4.8667 3.94427 4.68413 4.66675V4.66675ZM6.99996 11.6434C6.51579 10.9434 6.13663 10.1676 5.88579 9.33342H8.11413C7.86329 10.1676 7.48413 10.9434 6.99996 11.6434ZM8.36496 8.16675H5.63496C5.58246 7.78175 5.54163 7.39675 5.54163 7.00008C5.54163 6.60342 5.58246 6.21258 5.63496 5.83342H8.36496C8.41746 6.21258 8.45829 6.60342 8.45829 7.00008C8.45829 7.39675 8.41746 7.78175 8.36496 8.16675ZM8.51079 11.4101C8.86079 10.7626 9.12913 10.0626 9.31579 9.33342H11.0366C10.4715 10.3066 9.57486 11.0437 8.51079 11.4101V11.4101ZM9.54329 8.16675C9.58996 7.78175 9.62496 7.39675 9.62496 7.00008C9.62496 6.60342 9.58996 6.21842 9.54329 5.83342H11.515C11.6083 6.20675 11.6666 6.59758 11.6666 7.00008C11.6666 7.40258 11.6083 7.79342 11.515 8.16675H9.54329Z",
        fill: "#196CFF"
      })
    )
  );
};

//   GlobeIcon.defaultProps = {
//     color: "primary",
//   }

exports.default = (0, _styledComponents.withTheme)(GlobeIcon);


//////////////////
// WEBPACK FOOTER
// ./~/buoy-icons/dist/icons/GlobeIcon.js
// module id = 421
// module chunks = 168707334958949